import { CardType, ProductCardProps } from '../../types';
import { StatusEnum } from '@/types/cart';
import useTranslation from 'next-translate/useTranslation';
import { twMerge } from 'tailwind-merge';

const CardHeadSoldOut: React.FC<Partial<ProductCardProps & CardType>> = props => {
  const { data, className, cardType } = props;
  const { t } = useTranslation('common');

  return (
    data?.sold_status === StatusEnum.sold_out && (
      <div
        className={twMerge(
          'top-0 left-0 absolute bottom-0 right-0',
          'flex flex-col justify-center items-center',
          'rounded text-center enki-body-2xs z-[1] leading-5 bg-[#333] bg-opacity-50 text-reserved-true-white',
          className
        )}
        data-role="soldout"
        aria-describedby="soldout-description">
        <div id="soldout-description">{t('sold_out')}</div>
        {
          /* 横向的卡片展示在加购按钮上面 tooltip */
          cardType === 'vertical' && <div className="mt-1">{data?.restock_tip}</div>
        }
      </div>
    )
  );
};

export default CardHeadSoldOut;
